var exports = {
  "l9": "Trigger__Q-6W5i",
  "KQ": "ToggleIcon__dK-eIR",
  "UC": "Content__8G9oLN",
  "i2": "SummaryContent__I9EMfo",
  "Jy": "NestedSectionSlot__apF-6G",
  "Y4": "Segment__Eke91Z",
  "eN": "Flat__b7JBpB",
  "wn": "Section__U4NDm5",
  "y0": "SectionSlot__c8H8SO",
  "KG": "UnspacedSlot__16orT0",
};

module.exports = exports;
